import { render, staticRenderFns } from "./AutoReplies.vue?vue&type=template&id=2c7364b7&"
import script from "./AutoReplies.vue?vue&type=script&lang=js&"
export * from "./AutoReplies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports